module.exports = __webpack_public_path__ + "static/img/button9.cf383e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button9.png
// module id = ZYoG
// module chunks = 4